import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ExternalLink, Code2 } from 'lucide-react';
import { GithubIcon } from './SocialIcons';
import { useSectionData } from '../hooks/useSectionData';
import { fetchProjects, attr, getImageUrl } from '../services/api';

export default function Projects() {
  const items = useSectionData(fetchProjects);
  const { ref, inView } = useInView({ threshold: 0.08, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="projects" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">projects</p>
          <h2 className="section-title">Selected Work</h2>
          <div className="section-line" />
        </header>

        <div className="projects-grid">
          {items.map((item, i) => {
            const a = attr(item);
            const thumb = getImageUrl(a.thumbnail);
            const techs = Array.isArray(a.tech_stack) ? a.tech_stack : [];
            const year = a.year || '';
            const role = a.role || '';

            return (
              <article key={i} className="project-card">
                {thumb ? (
                  <img
                    src={thumb}
                    alt={a.name}
                    className="project-thumb"
                    loading="lazy"
                  />
                ) : (
                  <div className="project-thumb-placeholder" aria-hidden="true">
                    <Code2 size={32} />
                  </div>
                )}

                <div className="project-body">
                  <h3 className="project-name">{a.name}</h3>
                  <div className="project-meta">
                    {role && <span>{role}</span>}
                    {year && <span>·</span>}
                    {year && <span>{year}</span>}
                  </div>
                  {a.description && (
                    <p className="project-desc">{a.description}</p>
                  )}
                  {techs.length > 0 && (
                    <div className="project-tags">
                      {techs.map(t => <span key={t} className="badge">{t}</span>)}
                    </div>
                  )}
                </div>

                {(a.deployment_url || a.repository_url) && (
                  <div className="project-links">
                    {a.deployment_url && (
                      <a
                        href={a.deployment_url}
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label={`Live demo: ${a.name}`}
                      >
                        <ExternalLink size={13} /> Live Demo
                      </a>
                    )}
                    {a.repository_url && (
                      <a
                        href={a.repository_url}
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label={`Repository: ${a.name}`}
                      >
                        <GithubIcon size={13} /> Repository
                      </a>
                    )}
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
